export default __webpack_public_path__ + "static/media/bg.7f3f4d47.jpg";